import { selectIsSignedOutManually } from 'modules/auth/store/selectors';
import { Placeholder } from 'modules/common/components/Placeholder';
import { useAppSelector } from 'store/useAppSelector';

export interface ManualLogOutGuardProps {
  children?: React.ReactNode;
  fallback?: React.ReactNode;
}

export const ManualLogOutGuard = ({
  children = null,
  fallback = null,
}: ManualLogOutGuardProps) => {
  const isSignedOutManually = useAppSelector(selectIsSignedOutManually);

  return (
    <Placeholder hasPlaceholder={isSignedOutManually} placeholder={fallback}>
      {children}
    </Placeholder>
  );
};
